import { useState } from 'react'
import { cn } from '@/lib/utils'

interface CountryFlagProps {
  countryCode: string
  className?: string
  alt?: string
}

/**
 * Converts an ISO 3166-1 alpha-2 country code into its corresponding flag emoji
 * by mapping each letter to its Unicode regional indicator symbol (offset 127397 from ASCII).
 * @example countryCodeToFlagEmoji('PL') // '🇵🇱'
 */
export function countryCodeToFlagEmoji(code: string): string {
  return [...code.toUpperCase()].map((c) => String.fromCodePoint(c.charCodeAt(0) + 127397)).join('')
}

/**
 * Displays a country flag using flagcdn.com service
 * Falls back to country code badge if flag fails to load
 */
export function CountryFlag({ countryCode, className, alt }: CountryFlagProps) {
  const [failed, setFailed] = useState(false)
  const code = countryCode.toLowerCase()

  return (
    <>
      {!failed && (
        <img
          src={`https://flagcdn.com/w20/${code}.png`}
          srcSet={`https://flagcdn.com/w40/${code}.png 2x`}
          alt={alt ?? countryCode}
          className={cn('inline-block rounded-sm', className)}
          onError={() => setFailed(true)}
        />
      )}
      <span className="shrink-0 rounded border px-1.5 py-0.5 font-mono text-[11px] leading-none text-muted-foreground">
        {countryCode}
      </span>
    </>
  )
}
